import React, { useEffect, useState } from "react";
import { Flex } from "antd";
import { useDispatch } from "react-redux";
import ModalComponent from "@/components/modal";
import ButtonComponent from "@/components/button/Button";
import { setModalOpen } from "@/reducers/commonSlice";
import TextArea from "antd/es/input/TextArea";

const RequestWithReason = ({
  isOpen,
  message = "",
  details = {},
  onSubmit = () => {},
  onClose = () => {},
}) => {
  const dispatch = useDispatch();
  const [comment, setComment] = useState("");
  const handleSubmit = () => {
    onSubmit({ ...details, comment });
  };
  const handleCancel = () => {
    onClose();
    dispatch(setModalOpen(false));
  };
  useEffect(() => {
    if (isOpen) {
      setComment("");
    }
  }, [isOpen]);
  return (
    <ModalComponent isOpen={isOpen} width={347}>
      <Flex vertical gap="1rem" align="center">
        <div className="icon-wrapper">
          <img src="/assets/images/confirm.svg" alt="" />
        </div>
        <div className="body-b1 text-center">{message}</div>
        <TextArea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          autoSize={{ minRows: 4, maxRows: 7 }}
          placeholder="Enter your comment..."
        />
        <Flex gap={"1rem"}>
          <ButtonComponent label="Confirm" type="primary" onClick={handleSubmit} />
          <ButtonComponent label="Cancel" type="default" onClick={handleCancel} />
        </Flex>
      </Flex>
    </ModalComponent>
  );
};

export default RequestWithReason;
